import create from 'zustand'
import { devtools } from 'zustand/middleware'

export type CameraInputMethods = 'Drag' | 'Gyro' | 'Both' | 'None'

export interface AppState {
  inputMethod: CameraInputMethods,
  updateInputMethod: (newValue: CameraInputMethods) => void
  roomVisible: boolean
  showRoom: () => void
  hideRoom: () => void
}

export const useAppStore = create<AppState>()(
  devtools(
    (set) => ({
      inputMethod: 'None',
      updateInputMethod: (newValue: CameraInputMethods) => set(() => ({ inputMethod: newValue })),
      roomVisible: false,
      showRoom: () => set(() => ({ roomVisible: true })),
      hideRoom: () => set(() => ({ roomVisible: false }))
    }),
    {
      name: 'app-storage'
    }
  )
)
